import { CandidateJobMatchProfileComponent } from "./candidate-job-match-profile.component";
export const CandidateJobMatchProfileModule = angular
    .module('candidateJobMatchProfile', [])
    .component(CandidateJobMatchProfileComponent.selector, CandidateJobMatchProfileComponent.component)
    .name;
//# sourceMappingURL=candidate-job-match-profile.module.js.map